import { render, staticRenderFns } from "./HeaderBreadcrumbs.vue?vue&type=template&id=02488df0&scoped=true"
import script from "./HeaderBreadcrumbs.vue?vue&type=script&lang=js"
export * from "./HeaderBreadcrumbs.vue?vue&type=script&lang=js"
import style0 from "./HeaderBreadcrumbs.vue?vue&type=style&index=0&id=02488df0&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "02488df0",
  null
  
)

export default component.exports